var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Drag',{class:{ 'no-show': _vm.isDisabled },on:{"drag-start":_vm.dragStart,"dragging":_vm.dragging,"drag-stop":_vm.dragStop}},[_c('v-icon',{staticClass:"grabbable"},[_vm._v("mdi-drag")])],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }